export const sanitizeLocation = (locations = '') => (
  // delete last semicolon and speicial characters including [;,'\s-]
  locations
    .trim()
    .replace(/[^A-Za-z0-9'\s-]/g, '')
    .replace(/[\s'-]+/g, '-')
    .toLowerCase()
);

export const sanitizeArea = (area) => {
  if (area) {
    return encodeURIComponent(area).replace(/%20/g, '+').replace(/\*/g, '') || undefined;
  }
  return undefined;
};
